
import React, { useEffect, useRef, useState } from "react";
// @ts-ignore
import { Button, Card, Col, ProgressBar, Row } from "react-bootstrap";
import { FaRocket } from "react-icons/fa";
import "./Linearloader.scss"
import ModalPopup from "../DataLineage/InfoModal";
import { useAuth } from "../../Contexts/AuthContext";

const PlasmaLoader = () => {
  return (
    <div className="tube-container">
      <div className="plasma-packet"></div>
    </div>
  );
};

type PackageStatusResponse = {
  status: string;
  // …any other fields your API returns
};

const DroppedJobCard = ({ 
  // @ts-ignore
  job, packageId, setShowProgress, setJobsToShowProgressFor, setJobs, selectedTargets, env, setdepPkgStatus
}) => {
  const { tokens } = useAuth();
  const key = 'jobsArray';
  const storedData = JSON.parse(localStorage.getItem(key));
  const [showStatusModal, setShowStatusModal]  =useState<boolean>(false)
  const [deploymentFailed, setDeploymentFailed] = useState(false)

  const packageIdFound = storedData?.find((item:any) => item.envName === env)?.[env] || "N/A";

  const usePackageStatusPolling = (
    pkgId: number,
    onComplete: (id: number, data: PackageStatusResponse) => void,
    intervalMs: number = 4000
  ) =>{
    const onCompleteRef = useRef(onComplete);
    onCompleteRef.current = onComplete;
  
    useEffect(() => {
      // @ts-ignore
      if (pkgId === null || !tokens.accessToken) return;
  
      const timer = setInterval(async () => {
        try {
          const customer_id = localStorage.getItem("customer_id")
          const environment_id = localStorage.getItem("environment_id")
          const response = await fetch(`${process.env.REACT_APP_API_URL}deployment_pkg/${pkgId}/status?customer_id=${customer_id}&environment_id=${environment_id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokens.accessToken}`,
            },
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const data: PackageStatusResponse = await response.json();
  
          if (data.status === "COMPLETED" || data.status === "FAILED") {
            if (data.status === "FAILED"){
              setDeploymentFailed(true)
            }
            setShowStatusModal(true)

            setTimeout(() => {
              setdepPkgStatus(false)
              setShowStatusModal(false);

              onCompleteRef.current(pkgId, data);

              setDeploymentFailed(false)

              clearInterval(timer);
            }, 4000);
          }
        } catch (err) {
          console.error(`Error polling status for package ${pkgId}:`, err);
        }
      }, intervalMs);
  
      return () => clearInterval(timer);
    }, [pkgId, intervalMs, tokens.accessToken]);
  }

  const handleClear = () => {
    
    if (storedData) {
      try {
        const list = storedData;
        if (Array.isArray(list)) {
          const filteredList = list.filter((item) => item.envName !== env);
          
          if (filteredList.length > 0) {
            localStorage.setItem("jobsArray", JSON.stringify(filteredList));
          } else {
            localStorage.removeItem("jobsArray");
          }
        }
      } catch (error) {
        console.error('Error parsing localStorage data:', error);
      }finally{
        window.location.reload();
      }
    }
  };

  const handleHide = () => {
    setShowStatusModal(false)  
    setJobsToShowProgressFor(null)
  };

  usePackageStatusPolling(
    packageId,
    () => {
      handleClear();
    },
    4000
  );

  return (
    <>
    {!showStatusModal &&
    <Card className="shadow border-0 mx-auto" style={{ width: "85%", borderRadius: '12px', backgroundColor: '#ffffff' }}>
      <Card.Body className="p-4">
        <div className="d-flex align-items-center mb-4">
          <div className="d-flex justify-content-center align-items-center bg-light rounded-circle p-2 me-3">
            <FaRocket size={24} className="text-primary" />
          </div>
          
          <div className="d-flex flex-grow-1 justify-content-between align-items-center">
            <h5 className="m-0 fw-bold text-dark">{env}</h5>
            <div className="d-flex align-items-center">
              <span className="text-muted me-2">Package ID:</span>
              <span className="fw-semibold text-truncate" style={{ maxWidth: "180px" }}>{packageIdFound}</span>
            </div>
          </div>
        </div>
        
        <PlasmaLoader/>
      </Card.Body>
    </Card>
    }
    <ModalPopup
    show={showStatusModal}
    onHide={handleHide}
    bodyHead="Info Message"
    bodyTitle={deploymentFailed ? "Deployment Failed for the Package" :"Package Deployed Successfully"}
    />
</>
  );
};

export default DroppedJobCard;
